<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="form" v-loading="loading">
    <form class="form" @submit.prevent="handleSubmit(onSubmit)">
      <div class="display-grid">
        <div class="display-col">
          <span>Tên OKR<span style="color: red">*</span></span>
          <ValidationProvider class="w-100" vid="name" name="Tên OKR" rules="required" v-slot="{ errors }">
            <el-input v-model="form.name" placeholder="Nhập tên OKR"/>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="display-col">
          <span>Phân loại<span style="color: red">*</span></span>
          <ValidationProvider class="w-100" vid="type" name="Phân loại" rules="required" v-slot="{ errors }">
            <el-select v-model="form.type" placeholder="Select" class="w-100">
              <el-option
                  v-for="item in typeOkrOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="display-col">
          <span>KPI mục tiêu<span style="color: red">*</span></span>
          <ValidationProvider class="w-100" vid="kpi-target" name="KPI mục tiêu" rules="required" v-slot="{ errors }">
            <el-input v-model="form.kpiTarget" placeholder="Nhập KPI mục tiêu"/>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="display-col">
          <span>KPI tối thiểu</span>
          <ValidationProvider class="w-100" vid="kpi-min" name="KPI tối thiểu" rules="" v-slot="{ errors }">
            <el-input v-model="form.kpiMin" placeholder="Nhập KPI tối thiểu"/>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="display-col">
          <span>Phòng ban <span style="color: red">*</span></span>
          <ValidationProvider class="w-100" vid="department" name="Phòng ban" rules="required" v-slot="{ errors }">
            <el-select v-model="form.departmentId" placeholder="Chọn phòng ban" filterable class="w-100">
              <el-option
                  v-for="item in departments"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="display-col" id="teamlead">
          <span>Lựa chọn Teamlead OKR <span style="color: red">*</span></span>
          <ValidationProvider class="w-100" vid="leader" name="Teamlead OKR" rules="required" v-slot="{ errors }">
            <el-select
                ref="userSelect"
                v-model="form.leaderId"
                filterable
                remote class="w-100"
                clearable
                placeholder="Tìm kiếm nhân sự"
                :remote-method="remoteMethod"
                :loading="loading">
              <el-option
                  v-for="item in leaderOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
      </div>
      <div class="display-col" style="margin-top: 10px" id="find-user">
        <span>Nhân sự tham gia<span style="color: red">*</span></span>
        <ValidationProvider class="w-100" vid="exp" name="Nhân sự tham gia" rules="required" v-slot="{ errors }">
          <el-select
              ref="userSelect"
              v-model="form.userIds"
              filterable size="large"
              remote class="w-100"
              multiple @change="clearFilter"
              collapse-tags clearable
              placeholder="Tìm kiếm nhân viên"
              :remote-method="remoteMethod"
              :loading="loading">
            <el-option
                v-for="item in humanOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                errors[0]
              }}
            </div>
          </div>
        </ValidationProvider>
      </div>
      <div class="display-grid">
        <div class="display-col" style="margin-top: 10px">
          <span>Số EXP của OKR<span style="color: red">*</span></span>
          <ValidationProvider class="w-100" vid="exp" name="Số EXP của OKR" rules="required" v-slot="{ errors }">
            <el-input v-model="form.expTarget" placeholder="Nhập số EXP của OKR"/>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="display-col" style="margin-top: 10px">
          <span>Điền link thành phẩm</span>
          <ValidationProvider class="w-100" vid="result" name="Link thành phẩm OKR" rules="" v-slot="{ errors }">
            <el-input v-model="form.result" placeholder="Nhập link thành phẩm OKR"/>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
      </div>
      <div style="display: flex; justify-content: end; gap: 2px; margin-top: 10px; width: 100%;">
        <el-button type="info" @click="closeDialog">Hủy</el-button>
        <el-button
            native-type="submit"
            type="primary" :disabled="disableSubmit"
            style="background: #472F92; color: white"
        >
          <i class="el-icon-collection-tag"></i> Lưu thông tin
        </el-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { CREATE_OKR, FIND_USER_BY_KEYWORD, GET_OKR_DETAIL, UPDATE_OKR } from "@/core/services/store/okrs/okr.module";
import { typeOkrOption } from "@/common/define";
import { GET_DEPARTMENT } from "@/core/services/store/user/users.module";

export default {
  name: 'FormOKR',
  props: {
    okrId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      form: {
        name: null,
        type: 1,
        kpiTarget: null,
        kpiMin: null,
        expTarget: null,
        userIds: [],
        leaderId: null,
        departmentId: null,
        result: null,
      },
      typeOkrOption,
      humanOptions: [],
      leaderOptions: [],
      queryUser: null,
      page: 1,
      perPage: 1000,
      disableSubmit:false,
      departments: []
    }
  },
  created() {
    this.getListDepartment()
    if (this.okrId) {
      this.loading = true
      this.$store.dispatch(GET_OKR_DETAIL, this.okrId).then(res => {
        if (!res.error) {
          this.form.name = res.data.name
          this.form.type = res.data.type;
          this.leaderOptions.push(res.data?.leader)
          this.form.kpiMin = res.data.kpi_min;
          this.form.expTarget = res.data.exp_target;
          this.form.kpiTarget = res.data.kpi_target;
          this.form.userIds = res.data?.okr_users?.map(item => item.id)
          this.form.result = res.data?.result ?? ''
          this.form.departmentId = res.data?.department_id
          this.form.leaderId = res.data?.leader_id
          this.humanOptions = res.data?.okr_users ?? []
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.loading = false);
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    onSubmit() {
      this.disableSubmit = true
      const basePayload = {
        name: this.form.name,
        type: this.form.type,
        kpi_target: this.form.kpiTarget,
        kpi_min: this.form.kpiMin,
        user_ids: this.form.userIds,
        exp_target: this.form.expTarget,
        leader_id: this.form.leaderId,
        department_id: this.form.departmentId,
        result: this.form.result
      }
      const updatePayload = {
        id: this.okrId,
        ...basePayload
      }
      this.$store.dispatch(this.okrId ? UPDATE_OKR : CREATE_OKR, this.okrId ? updatePayload : basePayload).then(res => {
        if (!res.error) {
          this.closeDialog()
          this.$message.success(this.okrId ? 'Cập nhật OKR thành công' : 'Tạo OKR thành công')
          this.$emit('getListOkr')
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.disableSubmit = false)
    },
    remoteMethod(query) {
      if (query !== '') {
        this.queryUser = query
        this.loading = true;
        setTimeout(() => {
          this.loading = false
          this.getUsers()
        }, 400)
      } else {
        this.humanOptions = [];
        this.leaderOptions = [];
      }
    },

    clearFilter() {
      this.$nextTick(() => {
        const select = this.$refs.userSelect
        if (select) {
          const input = select.$el.querySelector('.el-select__input')
          if (input) {
            input.value = ''
            const evt = new Event('input', { bubbles: true })
            input.dispatchEvent(evt)
          }
        }
      })
    },

    getUsers() {
      const payload = {
        keyword: this.queryUser,
      }
      this.$store.dispatch(FIND_USER_BY_KEYWORD, payload).then(res => {
        if (!res.error) {
          this.humanOptions = res.data ?? []
          this.leaderOptions = res.data ?? []
        }
      })
    },
    getListDepartment() {
      this.$store.dispatch(GET_DEPARTMENT).then(res => {
        if (!res.error) {
          this.departments = res.data ?? []
        }
      })
    }
  }
}
</script>

<style>
.display-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.display-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 20px;
}
</style>
